import DATE_CONSTANTS from 'trustar-2.0/utils/Date.constants';

export const TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2':  'MEDIUM',
  '3': 'HIGH',
};

export const TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED',
};
export const TRIAGE_OPTIONS = [
  { label: 'Unresolved', payload: PHISHING_SCORE_VALUES.UNRESOLVED },
  { label: 'Confirmed', payload: PHISHING_SCORE_VALUES.CONFIRMED },
  { label: 'Ignored', payload: PHISHING_SCORE_VALUES.IGNORED }
];
export const DATE_OPTIONS = [
  { label: 'Previous 1 Month', payload: DATE_CONSTANTS.LAST_MONTH },
  { label: 'Previous 14 Days', payload: DATE_CONSTANTS.LAST_FOURTEEN_DAYS },
  { label: 'Previous 7 Days', payload: DATE_CONSTANTS.LAST_SEVEN_DAYS },
  { label: 'Previous 1 Day', payload: DATE_CONSTANTS.YESTERDAY },
  { label: 'Previous 12 Hours', payload: DATE_CONSTANTS.LAST_TWELVE_HOURS },
  { label: 'Previous 1 Hour', payload: DATE_CONSTANTS.LAST_HOUR },
];


// TODO Naming
const SCORES_NOT_TO_FILTER_BY = ['UNKNOWN'];
export const SCORE_FILTER_OPTIONS = Object.values(TRIAGE_STATUSES_TO_NAMES).filter(score => !SCORES_NOT_TO_FILTER_BY.includes(score));


export const DEFAULT_DATE_OPTION = { label: 'Previous 1 Day', payload: DATE_CONSTANTS.YESTERDAY };


// WEBPACK FOOTER //
// ./src/app/components/phishing/views/constants.js